import { trackEvent } from '@domain/analytics/trackEvent';

export const trackNearbyWatersClicked = (searchTerm: string): void => {
  trackEvent({
    name: 'mykiss_search_nearby_selected',
    properties: { search_term: searchTerm },
  });
};
